import { render, staticRenderFns } from "./SeoContainer.vue?vue&type=template&id=22687226&"
import script from "./SeoContainer.vue?vue&type=script&lang=js&"
export * from "./SeoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports